<script>
  import { asteroid } from "@/meteor.js";
  import { fade } from "svelte/transition";
  export let send, receive
  let email = "";
  let password = "";

  async function login() {
    try {
      await asteroid.loginWithPassword({ email, password });
      history.pushState({}, '', '/')
    } catch(err){
      console.info({snack:{msg: err.reason, type: 'error'}})
      console.log('er', err)
    }
  }
</script>

<style>
  input {
    @apply bg-gray-200 shadow-inner mb-8 pl-2 w-full;
  }
</style>

<div class="flex flex-wrap justify-center content-center h-full text-center" in:fade out:fade>

  <div class="text-lg sm:text-xl md:text-3xl sm:w-1/2 md:w-1/3 w-full px-3">
    <div>
      <input type="text" bind:value={email} placeholder="email" />
    </div>
    <div>
      <input type="password" bind:value={password} placeholder="password" />
    </div>
    {#if email && password}
      <div in:fade>
        <button on:click={login} class="bg-green-500 px-6 py-2 rounded text-white">login</button>
      </div>
    {/if}
  </div>

</div>
<div in:receive={{ key: 'searchBox' }}         out:send={{ key: 'searchBox' }}></div>